import { isGenericChannelId } from 'conversations-thread-data/channel-configuration/public/types';
import Raven from 'raven-js';
import { useCallback } from 'react';
import once from 'transmute/once';
import { EditorCapabilitiesContext } from '../context/EditorCapabilitiesContext';
import { useAsyncGenericChannelsWithCapabilities } from '../hooks/useAsyncGenericChannelsWithCapabilities';
import { jsx as _jsx } from "react/jsx-runtime";
const reportMissingChannelData = once(({
  error,
  editorConfigKey
}) => {
  Raven.capturePageEvent(`Missing channel data in EditorCapabilitiesProvider for '${editorConfigKey}'`, {
    extra: {
      error
    }
  });
});
export const EditorCapabilitiesProvider = ({
  children,
  editorConfigKey,
  loadingState,
  errorState
}) => {
  const {
    data,
    loading,
    error
  } = useAsyncGenericChannelsWithCapabilities();
  const getChannelData = useCallback(() => {
    if (!data) {
      throw new Error('Cannot access EditorCapabilitiesContext without channel data');
    }
    if (!isGenericChannelId(editorConfigKey)) {
      throw new Error(`Cannot access EditorCapabilitiesContext for non-channel editor: '${editorConfigKey}'`);
    }
    return data[editorConfigKey];
  }, [data, editorConfigKey]);
  if (loading) {
    return loadingState;
  }
  const isMissingChannelData = isGenericChannelId(editorConfigKey) && (!data || !data[editorConfigKey]);
  if (isMissingChannelData) {
    reportMissingChannelData({
      error,
      editorConfigKey
    });
    return errorState;
  }
  return /*#__PURE__*/_jsx(EditorCapabilitiesContext.Provider, {
    value: {
      editorConfigKey,
      getChannelData
    },
    children: children
  });
};
EditorCapabilitiesProvider.displayName = 'EditorCapabilitiesProvider';